<div
  class="user-menu block bg-white border border-t-0 lg:absolute lg:right-0 lg:z-10 lg:top-16 lg:w-64 lg:origin-top-right"
  [ngClass]="{
    'lg:block': isMenuOpen(),
    'lg:hidden': !isMenuOpen()
  }">
  <div class="lg:py-1 lg:px-10" role="none">
    <ng-content />
  </div>
  <div class="close-menu-item py-1  hidden lg:flex justify-center cursor-pointer" (click)="toggleMenu($event)">
    <img alt="Fermer le menu" src="assets/img/user_arrow_up.svg" width="38" />
  </div>
</div>
